import React from 'react'
import PropTypes from 'prop-types'
import TitleBar from '../Layout/titleBar'
import { Row, Col } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import { EditOutlined } from '@material-ui/icons'
import Button from '@material-ui/core/Button'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles';
import NumberFormat from 'react-number-format'

import './styles.css'


const styles = theme => ({
  colorSwitchBase: {
    color: '#9FA1A4',
    '&$colorChecked': {
      color: '#F57922',
      '& + $colorBar': {
        backgroundColor: '#FABC90',
        opacity: '1'
      },
    },
  },
  colorBar: {
    backgroundColor: '#000',
    opacity: '0.12'
  },
  colorChecked: {
    color: '#F57922',
  },
  colorDisabled: {
    color: '#E4E6E8',
    '&$colorChecked': {
      color: '#FABC90',
      '& + $colorBar': {
        backgroundColor: '#FABC90',
        opacity: '1'
      },
    },
  }
});

const SucursalEdit = ({
  sucursal,
  error,
  handleOnEditSucursal,
  handleOnCancel,
  handleOnChange,
  handleChangeSwitchActivo,
  handleSucursalActivo,
  classes,
  sucursalCargada,
  getPreSucursal,
  editDatos,
  editSeguridad,
  setEditDatos,
  setEditSeguridad
}) => {

  return (
    <div>
      {sucursalCargada ? (
        <div className='crearEditarSucursal'>
          <TitleBar
            title={((sucursal.idSucursal === null) ? 'Nuevo' : 'Editar') + ' sucursal '}
            type='createArticulo'  /** tiene cancelar y guardar*/
            handleOnBack2={handleOnCancel}
            showSearch={false}
          />

          {/* panel */}
          <Row>
            <Col md={8}>
              <Paper className='myBox no-margin' style={{ margin: '0px', padding: '0px' }}>
                <div className='content no-margin title'>
                  <div style={{ height: '34px', paddingTop: '7px' }}>Datos de la sucursal</div>
                  {!editDatos && <IconButton
                    color='default'
                    onClick={() => setEditDatos(true)}
                    style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                  >
                    <EditOutlined />
                  </IconButton>}
                </div>
                <div className='content no-margin'>
                  <Row>
                    <Col md={6}>
                      <TextField className='myInput'
                        label='Nombre'
                        name='nombre'
                        autoComplete='off'
                        fullWidth
                        required
                        error={error && error.nombre}
                        disabled={!editDatos}
                        helperText={(error && error.nombre) ? error.nombre : ""}
                        value={sucursal.nombre}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ\s]*$/.test(value)) {
                            handleOnChange(e);
                          }
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <TextField className='myInput'
                        label='Dirección'
                        name='direccion'
                        autoComplete='off'
                        fullWidth
                        required
                        error={error && error.direccion}
                        disabled={!editDatos}
                        helperText={(error && error.direccion) ? error.direccion : ""}
                        value={sucursal.direccion}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^[a-zA-Z0-9áéíóúÁÉÍÓÚ\s]*$/.test(value)) {
                            handleOnChange(e);
                          }
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <TextField className='myInput'
                        label='Telefono'
                        name='telefono'
                        autoComplete='off'
                        fullWidth
                        required
                        error={error && error.telefono}
                        disabled={!editDatos}
                        helperText={(error && error.telefono) ? error.telefono : ""}
                        value={sucursal.telefono}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\+?[0-9]*$/.test(value)) {
                            handleOnChange(e);
                          }
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <TextField className='myInput'
                        label='Whatsapp'
                        name='whatsapp'
                        autoComplete='off'
                        fullWidth
                        required
                        error={error && error.whatsapp}
                        disabled={!editDatos}
                        helperText={(error && error.whatsapp) ? error.whatsapp : ""}
                        value={sucursal.whatsapp}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\+?[0-9]*$/.test(value)) {
                            handleOnChange(e);
                          }
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <TextField className='myInput'
                        label='Link ubicación'
                        name='linkUbicacion'
                        autoComplete='off'
                        fullWidth
                        required
                        error={error && error.linkUbicacion}
                        disabled={!editDatos}
                        helperText={(error && error.linkUbicacion) ? error.linkUbicacion : ""}
                        value={sucursal.linkUbicacion}
                        onChange={handleOnChange}
                      />
                    </Col>
                  </Row>
                </div>
                {editDatos && (
                  <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={6}>
                      <div class="buttons-footer2">
                        <Button className="btnSecundarioFlat" onClick={() => { setEditDatos(false); getPreSucursal(); }}>CANCELAR</Button>
                        <Button className="btnPrincipalFlat" onClick={() => { handleOnEditSucursal(); }}>GUARDAR</Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </Paper>
            </Col>
            <Col md={4}>
              <Paper className='myBox' style={{ margin: '0px 0px 32px 0px', padding: '0px' }}>
                <div className='content no-margin title'>
                  <div style={{ height: '34px', paddingTop: '7px' }}>Seguridad</div>
                  {!editSeguridad && <IconButton
                    color='default'
                    onClick={() => setEditSeguridad(true)}
                    style={{ marginLeft: 'auto', padding: '5px', background: '#46C082', borderRadius: '10px', color: '#FFFFFF' }}
                  >
                    <EditOutlined />
                  </IconButton>}
                </div>
                <div className='content no-margin'>
                  <Row>
                    <Col md={12}>
                      Sucursal Activa
                    </Col>
                    <Col md={12}>
                      <Switch
                        checked={sucursal.activo}
                        onChange={(e) => handleChangeSwitchActivo(e)}
                        disabled={!editSeguridad}
                        classes={{
                          switchBase: classes.colorSwitchBase,
                          checked: classes.colorChecked,
                          bar: classes.colorBar,
                          disabled: classes.colorDisabled
                        }}
                      />
                    </Col>
                  </Row>
                  {editSeguridad && (
                    <Row>
                      <Col md={6}>
                      </Col>
                      <Col md={6}>
                        <div class="buttons-footer2">
                          <Button className="btnSecundarioFlat" onClick={() => { setEditSeguridad(false); getPreSucursal() }}>CANCELAR</Button>
                          <Button className="btnPrincipalFlat" onClick={() => { setEditSeguridad(false); handleSucursalActivo() }}>GUARDAR</Button>
                        </div>
                      </Col>
                    </Row>
                  )}
                </div>
              </Paper>
            </Col>
          </Row>

        </div>
      ) : <div></div>}
    </div>
  )
}

export default withStyles(styles)(SucursalEdit);